module.exports = __webpack_public_path__ + "static/media/state.ebab6262.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/state-of-styling/assets/state.png
// module id = 381
// module chunks = 0